import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import Halo from '@/common/Halo';

export const StyledHalo = createComponent(Halo, {
  className: 'mx-auto l:mx-0'
});

export const BannerWrapper = createComponent('div', {
  className:
    'flex flex-col items-center justify-center bg-black text-white l:flex-row'
});

export const BannerText = createComponent('div', {
  className: 'grid gap-20 px-16 py-48 text-center l:px-[96px] l:text-left'
});

export const ContentReadMoreAreaWrapper = styled.div`
  background-color: white;
  padding: 16px 0 32px;
  text-align: center;
`;

export const ContentReadMoreSections = styled.div`
  display: flex;
  flex-flow: column;
  width: 90%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${legacyBreakpoints.s}px) {
    width: 75%;
    display: inline-block;
  }
`;

export const ContentReadMoreSectionBase = styled.div`
  background-color: white;
  padding: 19px 0;
  order: 1;
  position: relative;
  vertical-align: top;

  & p span {
    display: block;
    height: 18px;
    color: #183558;
    font-size: 24px;
    font-weight: 700;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: 19px;
    padding-bottom: 1em;
  }
  & p {
    color: #757989;
    font-size: 22px;
    font-weight: 300;
  }
`;

export const ContentReadMoreOverview = styled(ContentReadMoreSectionBase)`
  order: 1;

  @media (min-width: ${legacyBreakpoints.s}px) {
    text-align: left;
  }
`;

const ContentReadMoreSectionBottom = styled(ContentReadMoreSectionBase)`
  padding-bottom: 0;

  & h3 {
    color: #183558;
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    margin-top: 19px;
  }

  @media (min-width: ${legacyBreakpoints.s}px) {
    width: 50%;
    text-align: left;
    display: inline-block;
  }
`;

export const ContentReadMoreSectionTwo = styled(ContentReadMoreSectionBottom)`
  order: 3;
`;

export const ContentReadMoreSectionThree = styled(ContentReadMoreSectionBottom)`
  order: 5;
`;

export const ContentReadMoreSectionSeparatorBase = styled.div`
  height: 1px;
  background-color: #d9dde9;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 35px;

  @media (min-width: ${legacyBreakpoints.s}px) {
    display: none;
  }
`;

export const ContentReadMoreSectionSeparatorTwo = styled(
  ContentReadMoreSectionSeparatorBase
)`
  order: 2;
`;

export const ContentReadMoreSectionSeparatorFour = styled(
  ContentReadMoreSectionSeparatorBase
)`
  order: 4;
`;

export const ContentSectionTextBase = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  color: #757989;
  text-align: left;

  @media (min-width: ${legacyBreakpoints.s}px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const ContentSectionOverviewText = styled(ContentSectionTextBase)`
  @media (min-width: ${legacyBreakpoints.s}px) {
    margin-left: 0;
    width: 100%;
  }
`;

export const ContentSectionTextBottom = styled(ContentSectionTextBase)`
  & h3 {
    color: #757989;
    font-weight: 700;
    text-decoration: underline;
    margin-top: 19px;
  }

  @media (min-width: ${legacyBreakpoints.s}px) {
    margin-left: 0;
    width: 85%;
  }
`;
